import React from 'react';
import { AgentIcon } from 'src/components/chat/AgentIcon';

interface AgentFabProps {
  onClick: () => void;
}

export const AgentFab: React.FC<AgentFabProps> = ({ onClick }) => (
  <button
    aria-label="Open AI agent chat"
    data-testid="agent-fab"
    style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      width: '72px',
      height: '72px',
      borderRadius: '50%',
      backgroundColor: '#0972D3',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
      zIndex: 1000,
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      border: 'none',
      padding: 0,
    }}
    onClick={onClick}
    onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.3)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.25)'; }}
  >
    <AgentIcon size={44} />
  </button>
);
